var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Card, CardContent } from "@mui/material";
import styles from "./index.module.css";
function CardCartilha(props) {
    var Icon = props.icon;
    return (_jsx("div", __assign({ className: styles.container, onClick: props.onClick }, { children: _jsx(Card, __assign({ className: styles.card }, { children: _jsxs(CardContent, __assign({ className: styles.grid }, { children: [_jsx(Icon, { fontSize: "large" }), _jsx("h3", __assign({ className: styles.h3 }, { children: props.label })), _jsx("p", __assign({ className: styles.p }, { children: props.info }))] })) })) })));
}
export default CardCartilha;
